import { render, staticRenderFns } from "./BaoSi.vue?vue&type=template&id=4b9c84c6"
import script from "./BaoSi.vue?vue&type=script&lang=js"
export * from "./BaoSi.vue?vue&type=script&lang=js"
import style0 from "./BaoSi.vue?vue&type=style&index=0&id=4b9c84c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports